import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from "../../../../components/lib/modal";
import CustomButton from "../../../../components/lib/customButton";

export default function BatchGradeChangeModal({ isOpen, onClose, selectedStudents, gradeOptions, onConfirm }) {
    const [selectedGrade, setSelectedGrade] = useState("");

    useEffect(() => {
        if (isOpen && gradeOptions.length > 0) {
            setSelectedGrade(gradeOptions[0].value);
        }
    }, [isOpen, gradeOptions]);

    const handleConfirm = () => {
        if (!selectedGrade) {
            toast.warning("Por favor, selecione uma série.");
            return;
        }
        onConfirm(selectedGrade);
    };

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={onClose}
            title="Mudança de Série em Massa"
            hideFooter
            maxWidth="max-w-md"
        >
            <div className="flex flex-col gap-4">
                <p className="text-gray-600">
                    Você selecionou <strong>{selectedStudents?.length || 0}</strong> alunos.
                    Selecione a nova série para a qual eles serão movidos:
                </p>

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">Nova Série</label>
                    <select
                        className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 outline-none"
                        value={selectedGrade}
                        onChange={(e) => setSelectedGrade(e.target.value)}
                    >
                        {gradeOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-3 mt-2">
                    <p className="text-sm text-blue-700">
                        Essa ação atualizará o cadastro acadêmico de todos os selecionados imediatamente.
                    </p>
                </div>

                <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-gray-100">
                    <CustomButton
                        onClick={onClose}
                        text="Cancelar"
                        buttonType="cancel"
                    />
                    <CustomButton
                        onClick={handleConfirm}
                        text="Confirmar Mudança"
                        buttonType="confirm"
                    />
                </div>
            </div>
        </Modal>
    );
}